<template>
  <div class="redact-card-container">
    <v-toolbar class="redact-card-header" flat density="compact">
      <v-toolbar-title class="mx-4 my-3">
        <div class="d-flex align-center justify-space-between">
          <slot name="title" />
        </div>
      </v-toolbar-title>
    </v-toolbar>

    <v-card-text class="ma-4 pa-0 overflow-y-auto">
      <slot name="content" />
    </v-card-text>
  </div>
</template>

<script>
export default {
  name: 'PdfRedactingPanelWrapper',
}
</script>

<style scoped lang="scss">
  @import "@/scss/border-tokens";

  .redact-card-container {
    @include border-radius('border-radius-3');
    border: get-border();
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .redact-card-header {
    border-radius: get-radius('border-radius-3') get-radius('border-radius-3') 0 0;
    background-color: rgb(var(--v-theme-grey-25));
    border-bottom: get-border();
  }
</style>
